/**
 * Created by xuyq on 2021/1/22.
 */

export default {
    system:{
        success:'操作成功',
        logout:'登出'
    }
}
